import { useEffect } from 'react';
import { useBranding } from '../context/BrandingContext';

/**
 * Hook que atualiza as meta tags do documento (título, favicon) com base nas configurações de branding
 * Deve ser chamado em componentes de alto nível para garantir que as meta tags sejam atualizadas
 */
export const useDocumentMeta = () => {
  const { branding } = useBranding();

  useEffect(() => {
    // Atualiza o título da página
    document.title = branding.platformName;

    // Atualiza a meta tag de theme-color
    let themeColorMeta = document.querySelector('meta[name="theme-color"]');
    if (!themeColorMeta) {
      themeColorMeta = document.createElement('meta');
      themeColorMeta.setAttribute('name', 'theme-color');
      document.head.appendChild(themeColorMeta);
    }
    themeColorMeta.setAttribute('content', branding.colors.primary);

    // Atualiza o favicon se houver URL configurada
    if (branding.faviconUrl) {
      let faviconLink = document.querySelector('link[rel="icon"]') as HTMLLinkElement;
      if (!faviconLink) {
        faviconLink = document.createElement('link');
        faviconLink.setAttribute('rel', 'icon');
        document.head.appendChild(faviconLink);
      }
      faviconLink.setAttribute('href', branding.faviconUrl);

      // Também atualiza o apple-touch-icon se existir
      let appleTouchIcon = document.querySelector('link[rel="apple-touch-icon"]') as HTMLLinkElement;
      if (appleTouchIcon && branding.iconUrl) {
        appleTouchIcon.setAttribute('href', branding.iconUrl);
      }
    }
  }, [branding]);

  return { platformName: branding.platformName };
};

export default useDocumentMeta;
